<template>
    <v-layout row wrap class="mt-4 pl-4">
        <v-flex xs6 class="pl-1">
            <div class="fingerprint">&nbsp;Left retina</div>
            <v-layout row wrap class="pl-4">
                <v-flex xs2 v-for="retina in left_retinas">
                    <file-display :src="retina"/>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs6 >
            <div class="fingerprint">Right retina</div>
            <v-layout row wrap class="pl-2">
                <v-flex xs2 v-for="retina in right_retinas">
                    <file-display :src="retina"/>
                </v-flex>
            </v-layout>
        </v-flex>

    </v-layout>
</template>

<script>
    import FileDisplay from "../../components/FileDisplay";
    import HeaderText from "../../components/HeaderText";

    export default {
        name: "RetinaScan",
        components: {HeaderText, FileDisplay},
        props: ['left_retinas', 'right_retinas']
    }
</script>
